var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHamburger(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    t: 1675633403612,
    className: "icon",
    viewBox: "0 0 1024 1024",
    xmlns: "http://www.w3.org/2000/svg",
    "p-id": 2868,
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 200,
    height: 200,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M958.060195 237.681284c0 9.611915-7.792477 17.404392-17.404392 17.404392L79.092359 255.085676c-9.611915 0-17.404392-7.792477-17.404392-17.404392l0-90.030479c0-9.611915 7.792477-17.404392 17.404392-17.404392l861.562421 0c9.611915 0 17.404392 7.792477 17.404392 17.404392L958.059172 237.681284z",
    fill: "#ffffff",
    "p-id": 2869
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M958.060195 557.488007c0 9.611915-7.792477 17.404392-17.404392 17.404392L79.092359 574.892399c-9.611915 0-17.404392-7.792477-17.404392-17.404392l0-90.030479c0-9.611915 7.792477-17.404392 17.404392-17.404392l861.562421 0c9.611915 0 17.404392 7.792477 17.404392 17.404392L958.059172 557.488007z",
    fill: "#ffffff",
    "p-id": 2870
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M958.060195 877.29473c0 9.611915-7.792477 17.404392-17.404392 17.404392L79.092359 894.699122c-9.611915 0-17.404392-7.792477-17.404392-17.404392l0-90.030479c0-9.611915 7.792477-17.404392 17.404392-17.404392l861.562421 0c9.611915 0 17.404392 7.792477 17.404392 17.404392L958.059172 877.29473z",
    fill: "#ffffff",
    "p-id": 2871
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHamburger);
export default __webpack_public_path__ + "static/media/hamburger.ba1e907da6313e83227931e7ba4891aa.svg";
export { ForwardRef as ReactComponent };